import { render, staticRenderFns } from "./investor-intelligence.vue?vue&type=template&id=56ea5470"
import script from "./investor-intelligence.vue?vue&type=script&lang=js"
export * from "./investor-intelligence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports